/* 🤖 this file was generated by svg-to-ts */
export const matIconVibration: {
  name: 'vibration';
  data: string;
} = {
  name: 'vibration',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z"/></svg>`
};
